import { TServiceClientInitialState, TServiceClientPayloads } from '../types';

export const updateServiceClientState = (
    state: TServiceClientInitialState,
    payload: TServiceClientPayloads
) => ({
    ...state,
    loading: false,
    error: null,
    ...payload,
});
